import { render, staticRenderFns } from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=template&id=693cd088&scoped=true"
import script from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderOrderReceiptDetail.vue?vue&type=style&index=0&id=693cd088&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693cd088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('693cd088')) {
      api.createRecord('693cd088', component.options)
    } else {
      api.reload('693cd088', component.options)
    }
    module.hot.accept("./PurchaseOrderOrderReceiptDetail.vue?vue&type=template&id=693cd088&scoped=true", function () {
      api.rerender('693cd088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderOrderReceiptDetail.vue"
export default component.exports